import { useState, useEffect, useCallback } from 'react';
import ICAL from 'ical.js';
import { apiFetch } from './api';

export default function useCalendarEvents(refreshKey) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCalendar = useCallback(async () => {
    try {
      const res = await apiFetch('/api/calendar/events');
      if (!res.ok) {
        const body = await res.text();
        throw new Error(`Server error ${res.status}: ${body}`);
      }
      const text = await res.text();
      const parsed = ICAL.parse(text);
      const comp = new ICAL.Component(parsed);
      const vevents = comp.getAllSubcomponents('vevent');

      const allEvents = vevents.map((ve) => {
        const event = new ICAL.Event(ve);
        return {
          id: event.uid || Math.random().toString(36),
          summary: event.summary || '(No title)',
          start: event.startDate.toJSDate(),
          end: event.endDate.toJSDate(),
          allDay: event.startDate.isDate,
          location: ve.getFirstPropertyValue('location') || '',
          description: ve.getFirstPropertyValue('description') || '',
        };
      });

      allEvents.sort((a, b) => a.start - b.start);
      setEvents(allEvents);
      setError(null);
    } catch (err) {
      setError('Could not load calendar');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCalendar();
  }, [fetchCalendar, refreshKey]);

  return { events, loading, error };
}
